import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 24
}

/**
 * Stateless function representing an Hours of service North America icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <HosNAmIcon width={12} />
 */
const HosNAmIcon = props => (
    <SvgIcon {...props}>
        <path
            d="M24,14.5c0,3.04-2.46,5.5-5.5,5.5c-0.9,0-1.75-0.22-2.5-0.61v-1.16c0.72,0.48,1.58,0.76,2.5,0.76c2.48,0,4.5-2.02,4.5-4.5
	S20.98,10,18.5,10c-0.92,0-1.78,0.28-2.5,0.76V9.61C16.75,9.22,17.6,9,18.5,9C21.54,9,24,11.46,24,14.5z M15,19.29
	c-0.01,0.39-0.35,0.7-0.74,0.71h-1.91c-0.38-0.02-0.69-0.33-0.7-0.71V18H4.34v1.29c-0.01,0.39-0.32,0.7-0.71,0.71H1.71
	C1.32,19.99,1.01,19.68,1,19.29V18l0,0v-3.99c0-0.73,0.59-1.33,1.33-1.33v-1.35c-0.37,0-0.66-0.3-0.66-0.66v-2
	C1.66,8.3,1.96,8,2.33,8V4.67l0,0C2.33,4.3,2.63,4,3,4h10.02c0.37,0.01,0.66,0.3,0.66,0.67V8l0,0c0.01,0,0.01,0,0.02,0
	c0.36,0.01,0.66,0.31,0.65,0.67v2l0,0c0,0.37-0.3,0.66-0.66,0.66l0,0v1.35c0.73,0.01,1.31,0.6,1.31,1.33V19.29z M4.01,14.65
	L4.01,14.65c0-0.56-0.45-1.01-1.01-1.01s-1.01,0.45-1.01,1.01S2.44,15.66,3,15.66S4.01,15.21,4.01,14.65z M11,14.28
	c0-0.52-0.42-0.94-0.94-0.95H5.95C5.43,13.34,5,13.76,5,14.28v1.76c0,0.52,0.43,0.94,0.95,0.94h4.11c0,0,0,0,0.01,0
	c0.52-0.01,0.94-0.43,0.94-0.96V14.28z M12.34,8.94C12.34,8.94,12.34,8.94,12.34,8.94c0-0.52-0.42-0.94-0.94-0.94H4.61
	C4.09,8,3.67,8.42,3.66,8.94v2.11c0.01,0.52,0.43,0.94,0.95,0.94h6.78c0.52,0,0.94-0.42,0.94-0.94V8.94z M13,15.66
	c0.56,0,1.01-0.45,1.01-1.01l0,0c0-0.56-0.45-1.01-1.01-1.01s-1.01,0.45-1.01,1.01S12.44,15.66,13,15.66L13,15.66z M20.6,15.9
	l-1.6-1.6V11.5h-1v3.21l1.9,1.9L20.6,15.9z"
        />
    </SvgIcon>
)

HosNAmIcon.defaultProps = defaultProps

export { HosNAmIcon }
